import React, { useEffect, useState } from 'react';

import CardBase from '../../common/CardBase';
import TradePresenterCardImage from './TradePresenter/Card/TradePresenterCardImage';
// import TradePresenterCardBody from "./TradePresenter/Card/TradePresenterCardBody";
import TradePresenterCardHighlight from './TradePresenter/Card/TradePresenterCardHighlight';
import TradePresenterCardLinks from './TradePresenter/Card/TradePresenterCardLinks';
import FeaturedCard from '../../common/FeaturedCard/FeaturedCard';
import FeaturedCardDynamic from '../../common/FeaturedCard/FeaturedCardDynamic';
// import BackToSearch from "../../common/BackToSearch";
import TradePresenterPageHeader from './TradePresenter/Detail/TradePresenterPageHeader';
import Layout from '../../common/Layout';
import { urlTransform } from '@craftercms/content';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { useTheme, makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

import SummaryInfo from '../SummaryInfo';
import { useSiteInfo } from '../../crafter_site_core/hooks';

const useStyles = makeStyles((theme) => ({
  heroDisplay: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  featuredDisplay: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
}));

const HeaderImageDefault =
  '/static-assets/content/images/page-header-elements/header-image-default.png';

export default function TradePresenter(props) {
  const mediaQuerySmDown = useMediaQuery((theme) =>
    theme.breakpoints.down('sm')
  );
  const [renderUrl, setRenderUrl] = useState();
  const [cardImageUrl] = useState(null);

  const classes = useStyles();
  const theme = useTheme();
  const {
    ice,
    format = 'DETAIL',
    model: {
      craftercms: { path },
      summary = SummaryInfo(props.model),
      body_html_raw,
      highlight_s,
      pageHeaderImage_s,
      categories_o,
      pdf_o,
      buttons_o
    }
  } = props;
  const siteinfo = useSiteInfo();

  const fallbackImage = siteinfo?.tradePresenterDefaultCard_s;
  const preferredImage = summary ? summary.cardImage : null;
  const finalImage = preferredImage ? preferredImage : fallbackImage;
  const encodedFinal = encodeURI(finalImage);

  useEffect(() => {
    urlTransform('storeUrlToRenderUrl', path).subscribe((url) =>
      setRenderUrl(url)
    );
  }, [path]);

  const buttonsRender = (buttons) => {
    return buttons.map((item, index) => {
      let lengthh = buttons.length;
      return (
        <Grid
          key={index}
          item
          xs={12}
          md={lengthh === 1 ? 6 : 12 / lengthh}
          style={{ marginBottom: mediaQuerySmDown ? 16 : 0 }}
        >
          <Button
            variant='contained'
            color='secondary'
            href={item.link_s}
            target='_blank'
            style={{ width: '100%', height: '100%', textAlign: 'center' }}
            className='button-main'
          >
            {item.text_s}
          </Button>
        </Grid>
      );
    });
  };

  switch (format) {
    case 'DETAIL':
      return (
        <Layout>
          {/* BackToSearch is commented out until search can run with same filters on press or show same results (perhaps global context / state) when navigating back to the search page (memorisation (useMemo) not a use case for this perhaps?) */}
          {/* <BackToSearch /> */}
          <TradePresenterPageHeader
            ice={ice}
            title={summary.title}
            categories={summary.categories}
            subtitle={summary.subtitle}
            pageheaderimage={
              pageHeaderImage_s ? pageHeaderImage_s : HeaderImageDefault
            }
            pdf={pdf_o}
          />
          <Container maxWidth='lg'>
            <Box width={1} minHeight={16}>
              <Grid
                container
                direction='row-reverse'
                spacing={mediaQuerySmDown ? 0 : 10}
              >
                {buttons_o && buttonsRender(buttons_o)}
              </Grid>
            </Box>
            <div
              {...ice}
              className='bodyhtmlraw'
              dangerouslySetInnerHTML={{ __html: body_html_raw }}
              style={{ marginTop: theme.spacing(2) }}
            />
          </Container>
        </Layout>
      );
    case 'CARD':
      return (
        <>
          <CardBase contenttype='Practitioner Guide' categories={categories_o}>
            <TradePresenterCardImage
              image={encodedFinal}
              title={summary.title}
              subtitle={summary.subtitle}
              link={renderUrl}
            />
            <TradePresenterCardHighlight highlight={highlight_s} />
            {/* <TradePresenterCardBody snippet={summary.snippet} /> */}
            <TradePresenterCardLinks
              buttontext='read now'
              link={renderUrl}
              pdf={pdf_o}
            />
          </CardBase>
        </>
      );
    case 'FEATURED':
      return (
        <FeaturedCardDynamic
          contenttype='Practitioner Guide'
          title={summary.title}
          subtitle={summary.subtitle}
          snippet={summary.snippet}
          buttontext='view now'
          categories={summary.categories}
          image={cardImageUrl}
          icon='trade-presenter'
          link={renderUrl}
        />
      );
    case 'HERO':
      return (
        <Container maxWidth='lg'>
          <div className={classes.heroDisplay}>
            <FeaturedCard
              contenttype='Practitioner Guide'
              title={summary.title}
              subtitle={summary.subtitle}
              snippet={summary.snippet}
              buttontext='read now'
              categories={summary.categories}
              image={cardImageUrl}
              link={renderUrl}
              icon='trade-presenter'
            />
          </div>
          <div className={classes.featuredDisplay}>
            <FeaturedCardDynamic
              contenttype='Practitioner Guide'
              title={summary.title}
              subtitle={summary.subtitle}
              snippet={summary.snippet}
              buttontext='read now'
              categories={summary.categories}
              image={cardImageUrl}
              icon='trade-presenter'
              link={renderUrl}
            />
          </div>
        </Container>
      );
    default:
      console.error(`Unknown format "${format}"."`);
      return <h1>Unknown format.</h1>;
  }
}
